import { motion } from "framer-motion";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_startup-forge-114/artifacts/vlayxu0a_23Recurso%202.png";

export const AnimatedLogo = ({ size = 240 }) => {
  return (
    <motion.div
      data-testid="animated-logo"
      className="relative flex flex-col items-center"
      initial={{ opacity: 0, scale: 0.8, filter: "blur(14px)" }}
      animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
      transition={{ duration: 1.6, ease: [0.16, 1, 0.3, 1] }}
    >
      <div
        className="float-y relative"
        style={{ width: size, height: size }}
      >
        {/* Glow circular giratorio que engloba el emblema, con borde difuminado */}
        <div
          className="spin-slow absolute inset-0 rounded-full"
          style={{
            background:
              "conic-gradient(from 0deg, rgba(0,240,255,0) 0deg, rgba(0,240,255,0) 150deg, rgba(0,240,255,0.6) 300deg, rgba(0,240,255,0) 360deg)",
            maskImage:
              "radial-gradient(circle, transparent 56%, #000 78%, transparent 100%)",
            WebkitMaskImage:
              "radial-gradient(circle, transparent 56%, #000 78%, transparent 100%)",
            filter: "blur(5px)",
            opacity: 0.75,
          }}
        />
        {/* Halo suave radial */}
        <div
          className="absolute inset-0 rounded-full"
          style={{
            background:
              "radial-gradient(circle, rgba(0,240,255,0.16) 45%, rgba(0,240,255,0.05) 65%, transparent 78%)",
          }}
        />

        {/* Emblema recortado en círculo limpio */}
        <div className="absolute inset-0 overflow-hidden rounded-full border border-white/10 bg-black">
          <img
            src={LOGO_URL}
            alt="Xperimentad"
            draggable={false}
            className="absolute left-1/2 -translate-x-1/2"
            style={{ width: size * 1.32, height: size * 1.32, top: -size * 0.02, objectFit: "contain" }}
          />
          {/* Shine sweep */}
          <div className="pointer-events-none absolute inset-0">
            <div
              className="logo-shine absolute top-0 h-full w-1/3"
              style={{
                background:
                  "linear-gradient(90deg, transparent, rgba(255,255,255,0.18), transparent)",
              }}
            />
          </div>
        </div>
      </div>

      {/* Wordmark como texto real */}
      <span
        className="mt-5 font-light text-white"
        style={{
          fontSize: size * 0.115,
          letterSpacing: "0.42em",
          paddingLeft: "0.42em",
        }}
      >
        XPERIMENTAD
      </span>
    </motion.div>
  );
};

export default AnimatedLogo;
